'use client';

import { GeoCodeResult } from '@/hotdesk-ui/types/geo-code-result.type';
import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage'; // Import directly from redux-persist
import { persistReducer } from 'redux-persist';

const initialState: {
    currentSearch: GeoCodeResult | null
} = {
    currentSearch: null
}

export const searchSlice = createSlice({
  name: 'search',
  initialState: initialState,
  reducers: {
    setCurrentSearch: (state, action) => {
      state.currentSearch = action.payload;
    }
  },
});

export const { setCurrentSearch } = searchSlice.actions;

const persistConfig = {
    key: 'search',
    storage: storage
}

export default persistReducer(persistConfig, searchSlice.reducer);
